import styled from 'styled-components';

import AutoComplete from '../../atoms/AutoComplete';

export const StyledAutoComplete = styled(AutoComplete)`
  width: 100%;
  min-width: 250px;
  max-width: 300px;
`;

export const Wrapper = styled.div`
  box-shadow: 0 0 10px -1px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  min-width: 250px;
  width: 100%;
  z-index: 2;
`;
